export const COUNTRY_CODE = process.env.NEXT_PUBLIC_COUNTRY_CODE;
export const LOCAL_HOST_ADDRESS = "localhost:3000";
export const HOST =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_BASE_PATH
    : `http://${LOCAL_HOST_ADDRESS}`;
export const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
export const WHITELABEL_EDGE_ID = process.env.WHITELABEL_EDGE_ID;
export const WHITELABEL_EDGE_TOKEN = process.env.WHITELABEL_EDGE_TOKEN;
export const SHOPSITE_WEBSITE_UID = process.env.NEXT_PUBLIC_ITK_WEBSITE_UID;
export const BANK_TRANSFER_ACCOUNT =
  process.env.NEXT_PUBLIC_BANK_TRANSFER_ACCOUNT;
export const API_URL = process.env.API_URL;
export const LEGACY_API_KEY = process.env.LEGACY_API_KEY;
export const BASKET_API_URL = process.env.BASKET_API_URL;
// two options for api proxying:
// - NEXT_PUBLIC_ALLOW_API_PROXY exposes the api proxy route.
// - NEXT_PUBLIC_SHOULD_PROXY_API_REQUESTS directs all shopsite api requests to the proxy.
export const SHOULD_PROXY_API_REQUESTS =
  process.env.NEXT_PUBLIC_SHOULD_PROXY_API_REQUESTS === "true";
export const ALLOW_API_PROXY =
  process.env.NEXT_PUBLIC_ALLOW_API_PROXY === "true";
// in prod, api rewrites are handled in vercel config. in local dev we need to use proxy.ts.
// this is because to use vercel config in local dev, we'd have to use `vercel dev` (which would be fine except that it causes annoying issues with the locale routing).
export const API_PROXY_PATH =
  process.env.NODE_ENV === "production" ? `/api/z` : `/api-proxy`;
// Check if running in a sandbox environment (v0 sandbox domains)
const isSandboxEnvironment =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("vercel.run") ||
    window.location.hostname.includes("vusercontent.net"));
export const BASE_URL =
  (SHOULD_PROXY_API_REQUESTS || isSandboxEnvironment) &&
  typeof window !== "undefined"
    ? API_PROXY_PATH
    : process.env.NEXT_PUBLIC_BASE_URL;

// Root domains stripped from the incoming host to derive the tenant subdomain.
// A single ROOT_DOMAIN can't cover tenants on multiple TLDs (e.g. .iticket.io
// AND .iticket.co.nz), so we support a comma-separated ROOT_DOMAINS list and
// fall back to the known iTICKET TLDs. Sorted longest-first so the most
// specific suffix (e.g. ".iticket.co.nz") is stripped before ".iticket.io".
export const ROOT_DOMAINS = Array.from(
  new Set(
    (
      process.env.ROOT_DOMAINS ??
      [
        process.env.ROOT_DOMAIN ?? ".iticket.io",
        ".iticket.io",
        ".iticket.co.nz",
      ].join(",")
    )
      .split(",")
      .map((domain) => domain.trim())
      .filter(Boolean)
  )
).sort((a, b) => b.length - a.length);

// Derive the tenant hostname (e.g. "crl.stage") from the raw host header by
// stripping the local dev suffix and whichever known root domain matches.
export function getTenantHostname(host: string): string {
  let hostname = host.replace(".localhost:3000", "");
  for (const domain of ROOT_DOMAINS) {
    if (domain && hostname.endsWith(domain)) {
      hostname = hostname.slice(0, -domain.length);
      break;
    }
  }
  return hostname;
}

// Decide whether a request is for the main shopsite (vs a whitelabel tenant).
// This MUST run against the RAW host header, not the tenant hostname: the main
// shopsite (e.g. www.iticket.co.nz) shares the .iticket.co.nz root domain with
// whitelabel tenants (e.g. crl.stage.iticket.co.nz), so stripping the root
// domain first would make the shopsite indistinguishable from a tenant.
export function isShopsiteHost(host: string): boolean {
  const shopsiteHostname = process.env.NEXT_PUBLIC_BASE_PATH?.split("//")[1];
  return (
    host === "localhost:3000" ||
    (!!shopsiteHostname && host.includes(shopsiteHostname)) ||
    host.includes("vercel.run") ||
    host.includes("vusercontent.net")
  );
}
